@if (swiperVisible) {
  <swiper-container
    appSwiper
    [config]="swiperConfig"
    init="false"
    class="share-buttons social-media-swiper-container"
    [class.coloured]="
      iconsColor === RSVPConfirmationPageSectionIconsColorType.COLORED
    "
    [class.dark]="iconsColor === RSVPConfirmationPageSectionIconsColorType.DARK"
    [class.light]="
      iconsColor === RSVPConfirmationPageSectionIconsColorType.LIGHT
    "
    [class.theme]="
      iconsColor === RSVPConfirmationPageSectionIconsColorType.THEME
    "
    [class.edit-mode]="isEditMode"
    [class.align-end]="alignEnd"
  >
    @for (option of socialMediaTypes; track $index) {
      @if (!missingLink(option) || isEditMode) {
        <swiper-slide [class.bigger-size]="biggerSize">
          @if (asSvg) {
            <span
              class="fa-stack custom-icon-stack"
              [class.bigger-size]="biggerSize"
              [class.clickable]="!isEditMode"
              (click)="copyLink(option)"
            >
              <i class="fas fa-square fa-stack-2x"></i>
              <i
                class="fa-brands {{
                  SocialMediaType.getIcon(option)
                }} fa-stack-1x fa-inverse"
                [ngStyle]="{
                  color: event?.eventTemplate?.visual?.footerBackgroundColor
                }"
              ></i>
            </span>
          } @else {
            <span
              class="fa-stack custom-icon-stack"
              [class.bigger-size]="biggerSize"
              [class.clickable]="!isEditMode"
              (click)="copyLink(option)"
            >
              <i class="fas fa-square fa-stack-2x"></i>
              <i
                class="fa-brands {{
                  SocialMediaType.getIcon(option)
                }} fa-stack-1x fa-inverse"
                [ngStyle]="{
                  color: getThemeIconColors()
                }"
                [ngClass]="
                  iconsColor ===
                  RSVPConfirmationPageSectionIconsColorType.COLORED
                    ? option.toLowerCase()
                    : null
                "
                [class.disabled]="missingLink(option)"
              ></i>
            </span>
            <!--    <i
              class="fa-brands fa-square-{{ option.toLowerCase() }} share-icon"
              [ngStyle]="{
                color: getThemeIconColors()
              }"
              [ngClass]="
                iconsColor === RSVPConfirmationPageSectionIconsColorType.COLORED
                  ? option.toLowerCase()
                  : null
              "
              [class.disabled]="missingLink(option)"
              [class.clickable]="!isEditMode"
              (click)="copyLink(option)"
            ></i>-->
          }
        </swiper-slide>
      }
    }
  </swiper-container>
}
